import React from "react";
const ErrorMsg = ({ msg }) => <span className="error">{msg}</span>;

export default ErrorMsg;
